// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { ClarityTranslationFragmentDoc } from './ClarityTranslation.fragment.generated';
export const StoneClarityFragmentDoc = `
    fragment stoneClarity on StoneClarity {
  abbreviation
  systemCode
  translation(locale: $locale) {
    ...clarityTranslation
  }
}
    `;